<template>
  <div>
    <AccountingDashboard v-if="useNew" />
    <PortfolioDashboard v-else />
  </div>
</template>

<script>
import AccountingDashboard from './Dashboard2.vue';
import PortfolioDashboard from './dashboards/PortfolioDashboard.vue';

export default {
  components: {
    AccountingDashboard,
    PortfolioDashboard,
  },
  computed: {
    useNew() {
      const features = this.$store.getters.features;
      return features['event-sourced-txns'] === 'true';
    },
  },
};
</script>
